import React from 'react'
import { compose } from 'recompose'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Drawer from 'material-ui/Drawer'
import muiThemeable from 'material-ui/styles/muiThemeable'
import { refElements } from 'components/Canvas/renderer/utils/elementUtils'
import { updateElement, selectElement } from 'store/canvas/actions'
import { selectElementFromSelectedId } from 'store/canvas/selectors'
import MainHeader from 'components/headers/MainHeader'
import Modal from 'components/modals/Modal'
import RaisedButton from 'material-ui/RaisedButton';
import ElementFormController from './ElementFormController'
import ModalElementForm from './ModalElementForm'

const mapStateToProps = (state) => ({
  element: selectElementFromSelectedId(state)
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({ updateElement, selectElement }, dispatch)
);

const CanvasPanel = compose(
  muiThemeable(),
  connect(mapStateToProps, mapDispatchToProps),
)(
  ({
    open,
    width,
    muiTheme,
    element,
    updateElement,
    selectElement,
  }) => {
    const renderFormController = () => {
      switch (element.refElement) {
        case refElements.TEXT_EDITOR:
          return (
            <ModalElementForm
              value={element}
              onChange={updateElement}
              onClose={() => selectElement(null)}
            />
          )
        default:
          return (
            <ElementFormController
              element={element}
              updateElement={updateElement}
            />
          )
      }
    }
    return (
      <Drawer
        open={open}
        openSecondary
        width={width}
        containerStyle={{ zIndex: 1090, paddingTop: muiTheme.appBar.height }}
      >
        {element ?
          <div>
            <MainHeader filled noMarginBottom small>{element.name}</MainHeader>
            {renderFormController()}
          </div>
          :
          <MainHeader filled small>Please select an element.</MainHeader>
        }
      </Drawer>
    )
  }
)

CanvasPanel.propTypes = {}
CanvasPanel.defaultProps = {}

export default CanvasPanel



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/panel/CanvasPanel.js